"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.HandlePartialViewAnalytics = void 0;
const Name = exports.Name = 'handle-partial-view-analytics';
const HandlePartialViewAnalytics = exports.HandlePartialViewAnalytics = Name;
